define('drops/input/input',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/constants',
    'lq/util',
    'lq/tooltip',
    'jquery.placeholder',
    'lq/required',
    'lq'
], function ($, _, Drop, Style, constants, util, Tooltip, placeholder, Required, lq) {
    'use strict';

    var defaults = {
        data: {
            title: {
                option: Tooltip.hardcoded
            },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            useCustomImage: false,
            changedDelay: 500
        }
    };

    function Input(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.typeOfCurrentValue = constants.valueTypes.string;

        var inputType = this.data.maskedInput ? 'password' : 'text';  //type needs to be set before creating, because it cannot be changed
        this.$input = $('<input type=' + inputType + ' />')
	        .addClass('boxToBorderSize')
            .attr('name', this.data.name)
            .attr('tabindex', this.data.tabIndex)
			.attr('placeholder', this.data.watermark)
            .val(this.data.defaultValue || '')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.$element);

        if (this.data.maskedInput) {
            this.addTogglePassword();
            this.changeOpenEyeIcon();
        } else {
            this.removeTogglePassword();
        }

        this.$input[0].setAttribute('value', '');

        this.tooltip = new Tooltip(this, this.data.title, this.$input);

        var self = this;
        var focusLostEvent = this.getEventDataFor('focusLost');
        if (focusLostEvent.enabled) {
            this.$input.on('blur', function () {
                self.triggerEvent(focusLostEvent.raisedEventName);
            });
        }

        var enterPressedEvent = this.getEventDataFor('enterPressed');
        if (enterPressedEvent.enabled) {
            this.$input.on('keyup', function (event) {
                if (event.keyCode === 13) {
                    self.triggerEvent(enterPressedEvent.raisedEventName);
                }
            });
        }

        var changedEvent = this.getEventDataFor('changed');
        if (changedEvent.enabled) {
            this.subscribeEventHandler(this.$input, 'keydown', function () {
                if (!_.has(self, 'lastChangedEventValue'))
                    self.lastChangedEventValue = self.getValue();
            });
            this.subscribeEventHandler(this.$input, 'keypress input', _.debounce(function () {
                if (self.lastChangedEventValue !== self.getValue()) {
                    self.lastChangedEventValue = self.getValue();
                    self.triggerEvent(changedEvent.raisedEventName);
                }
            }, this.data.changedDelay));
        }

    	this.$element
	        .css({
	            whiteSpace: 'pre-wrap'
	        });

    	Style.renderStyles(this, null, this.$input);
    };

    Drop.extend(Input, Drop);

    Input.typeName = 'Input';

    Input.prototype.preRender = function () {
        this.tooltip.update();
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);
        Required.prototype.addRemoveRequiredIndicator(this);

        this.applyPosition();
        this.initialize();
    };

    Input.prototype.postRender = function () {
        this.$input.placeholder(); // needs to be done after rendering, otherwise it breaks IE9
    };

    Input.prototype.initialize = function () {
        var self = this;
        this.$input.on('keyup', function () {
            self.updateRequiredIndicator();
            this.setAttribute('value', this.value);
        });

        if (this.data.readOnly)
            this.$input.prop('readonly', true);

        if (this.data.hasMaxLength)
            this.$input.attr('maxlength', this.data.maxLength);
    };

    Input.prototype.focus = function() {
        this.$input.trigger('focus');
    };

    Input.prototype.getDefaultEventArg = function () {
        return this.getValue();
    };

    Input.prototype.getValue = function () {
        return this.formatter.convertToLicquidFormat(this.typeOfCurrentValue, this.$input.val());
    };

    Input.prototype.clearValue = function () {
        this.$input.val('');
        this.$input[0].setAttribute('value', '');
        this.lastChangedEventValue = '';
        this.updateRequiredIndicator();
    };

    Input.prototype.setValue = function (update) {
        var text = this.formatter.convertFromLicquidFormat(update.type, update.value === null ? '' : update.value);
        this.$input.val(text);
        this.$input[0].setAttribute('value', text);
        this.typeOfCurrentValue = update.type;
        this.lastChangedEventValue = update.value;
        this.updateRequiredIndicator();
    };

    Input.prototype.addTogglePassword = function () {
        var self = this;
        this.$togglePassword = $('<div class = "input-fa input-fa-eye">')
            .prop('title', 'Show password')
            .css({
                position: 'relative',
                top: '-50%',
                left: '-5px',
                marginTop: '-8px',
                float: 'right'
            })
            .on('click', function () {
                if (self.$input[0].type === "password") {
                    self.changeClosedEyeIcon();
                } else {
                    self.changeOpenEyeIcon();
                }
            })
            .appendTo(this.$element);
    };

    Input.prototype.removeTogglePassword = function () {
        if (this.$togglePassword) {
            this.$togglePassword.remove();
            delete this.$togglePassword;
        }
    };

    Input.prototype.getOpenEyeImagePath = function () {
        if (this.data.physicalFileOpenEye)
            return lq.getTenantUploads(this.data.physicalFileOpenEye);

        return null;
    };

    Input.prototype.getClosedEyeImagePath = function () {
        if (this.data.physicalFileClosedEye)
            return lq.getTenantUploads(this.data.physicalFileClosedEye);

        return null;
    };

    Input.prototype.changeOpenEyeIcon = function () {
        if (!this.$togglePassword) {
            this.addTogglePassword();
        }
        var type = 'open';
        var imagePath = this.getOpenEyeImagePath();
        if (imagePath && this.data.maskedInput && this.data.useCustomImage) {
            this.setCustomEyeImage(imagePath, type);
        } else if (this.data.maskedInput) {
            this.clearCustomEyeImage(type);
        }

        this.$input[0].type = "password";
    }

    Input.prototype.changeClosedEyeIcon = function () {
        if (!this.$togglePassword) {
            this.addTogglePassword();
        }
        var type = 'closed';
        var imagePath = this.getClosedEyeImagePath();
        if (imagePath && this.data.maskedInput && this.data.useCustomImage) {
            this.setCustomEyeImage(imagePath, type);
        } else if (this.data.maskedInput) {
            this.clearCustomEyeImage(type);
        }

        this.$input[0].type = "text";
    }

    Input.prototype.setCustomEyeImage = function(image, type) {
        this.$togglePassword
            .css({
                width: '16px',
                height: '16px',
                backgroundImage: 'url(' +  require.toUrl(image) + ')',
                backgroundSize: '100% 100%'
            })
            .removeClass('input-fa-eye input-fa-eye-slash');

        if (type === 'closed') {
            $(this.$togglePassword)
                .prop('title', 'Hide password');
        }
        else if (type === 'open') {
            $(this.$togglePassword)
                .prop('title', 'Show password');
        }
    };

    Input.prototype.clearCustomEyeImage = function(type) {
        $(this.$togglePassword)
            .css({
                width: '',
                height: '',
                backgroundImage: '',
                backgroundSize: ''
            });
        if (type === 'closed') {
            $(this.$togglePassword)
                .prop('title', 'Hide password')
                .addClass('input-fa-eye-slash')
                .removeClass('input-fa-eye');
        }
        else if (type === 'open') {
            $(this.$togglePassword)
                .prop('title', 'Show password')
                .addClass('input-fa-eye')
                .removeClass('input-fa-eye-slash');
        }
    };

    return Input;
});

